import { render, staticRenderFns } from "./Resources.vue?vue&type=template&id=acacfa8c&scoped=true&"
var script = {}
import style0 from "./Resources.vue?vue&type=style&index=0&id=acacfa8c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "acacfa8c",
  null
  
)

export default component.exports